// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/WaitingForAuthorization.scss
// module id = ./src/styles/WaitingForAuthorization.scss
// module chunks = 0